import { useNavigate } from "react-router-dom";
import {
  Zap,
  ListTodo,
  CalendarPlus,
  Upload,
  ReceiptText,
  Wallet,
  Share2,
  StickyNote,
  Sparkles,
} from "lucide-react";
import "./caseDetails.css";

// Right rail for Case Details — Quick Actions only (mockup style). The
// Team / Recent Activity / Snapshot cards now live in the page's hero rows.
export default function CaseDetailsRail({
  caseId,
  caseCollection,
  statusBucket,
  isOwner,
  isClient,
  isLocked,
  onAddHearing,
  onOpenTab,
  onEditNotes,
  onSummarizeAllOrders,
}) {
  const navigate = useNavigate();

  const canShare = caseCollection !== "disposed";

  const quickActions = [
    !isClient && {
      key: "task",
      label: "Add Task",
      icon: <ListTodo size={15} />,
      onClick: () => navigate(`/portal/add-task?caseId=${caseId}`),
    },
    statusBucket !== "disposed" &&
      !isLocked && {
        key: "hearing",
        label: "Add Hearing / Event",
        icon: <CalendarPlus size={15} />,
        onClick: onAddHearing,
      },
    {
      key: "upload",
      label: "Upload Document",
      icon: <Upload size={15} />,
      onClick: () => navigate(`/portal/case/${caseId}/case-files`),
    },
    isOwner &&
      !isClient && {
        key: "invoice",
        label: "Create Invoice",
        icon: <ReceiptText size={15} />,
        onClick: () => navigate(`/portal/create-invoice?case=${caseId}`),
      },
    {
      key: "expense",
      label: "Record Expense",
      icon: <Wallet size={15} />,
      onClick: () => onOpenTab("expenses"),
    },
    canShare && {
      key: "share",
      label: "Share Case",
      icon: <Share2 size={15} />,
      onClick: () => onOpenTab("allow-access"),
    },
    {
      key: "notes",
      label: "Case Notes",
      icon: <StickyNote size={15} />,
      onClick: () => (onEditNotes ? onEditNotes() : onOpenTab("comments")),
    },
    onSummarizeAllOrders && {
      key: "ai",
      label: "Summarise All Orders",
      icon: <Sparkles size={15} className="text-purple-500" />,
      onClick: onSummarizeAllOrders,
    },
  ].filter(Boolean);

  return (
    <aside className="cd-rail">
      <div className="cd-panel">
        <h3 className="cd-panel-title">
          <Zap size={14} className="cd-title-ic ic-green" />
          Quick Actions
        </h3>
        <div className="cd-qa-list">
          {quickActions.map((a) => (
            <button key={a.key} className="cd-qa-item" onClick={a.onClick}>
              {a.icon}
              {a.label}
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}
